export const BOOKS_BASE_URL = "books";
